import React from 'react';

const DOT_CONFIG = [
  { key: 'owner', label: 'Owner', check: (s) => s.team && s.team !== 'unknown' },
  { key: 'dashboard', label: 'Dashboard', check: (s) => s.has_dashboard },
  { key: 'logs', label: 'Logs', check: (s) => s.has_log_group },
  { key: 'alarms', label: 'Alarms', check: (s) => s.has_alarm },
  { key: 'runbook', label: 'Runbook', check: (s) => s.has_runbook },
];

export default function HealthDots({ service }) {
  return (
    <div className="flex items-center gap-1">
      {DOT_CONFIG.map(({ key, label, check }) => {
        const ok = check(service);
        return (
          <span
            key={key}
            title={`${label}: ${ok ? 'yes' : 'missing'}`}
            className={`w-2 h-2 rounded-full ${ok ? 'bg-emerald-500' : 'bg-gray-300'}`}
          />
        );
      })}
    </div>
  );
}
